'use strict';

// LPのスクロールリビール。.lp-reveal が画面内に入ったら .is-in を付与する。
// prefers-reduced-motion 尊重（即時表示）。LP以外のページでは対象が無く無害。
(function() {
  function init() {
    const els = document.querySelectorAll('.lp-reveal');
    if (els.length === 0) return;

    const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduce || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach((el) => io.observe(el));
  }

  document.addEventListener('turbolinks:load', init);
})();
